import { Clients } from './Component/Clients';
import { AddClients } from './Component/AddClients';
import { Navbarheader } from './Component/Navbarheader';
import { HashRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { UpdateClient } from './Component/UpdateClient';
import { AddDevelopers } from './Component/AddDevelopers';
import { AllDevelopersMain } from './Component/AllDevelopersMain';
import { UpdateOneDeveloperData } from './Component/UpdateOneDeveloperData';
import { AllProjects } from './Component/All Project/AllProjects';
import { AddProjects } from './Component/All Project/AddProjects';
import { AddCity } from './Component/Cities/AddCity';
import { UpdateProject } from './Component/All Project/UpdateProject';
import { AllCitiesShow } from './Component/Cities/AllCitiesShow';
import { UpdateCity } from './Component/Cities/UpdateCity';
import { AddSales } from './Component/Sales/AddSales';
import { SalesMain } from './Component/Sales/SalesMain';
import { UpdateSales } from './Component/Sales/UpdateSales';
import { Rigister } from './Component/Auth/Rigister';
import { Login } from './Component/Auth/Login';
import { SendLeedPage } from './Component/SendLeedPage';
import { RecievedLeedPage } from './Component/RecievedLeedPage';
import { useEffect, useState } from 'react';
import { UpdateStage } from './Component/UpdateStage';
import { ChannelPage } from './Pages/ChannelPage';
import { AddChannal } from './Component/Channel/AddChannal';
import { UpdateChanel } from './Component/Channel/UpdateChanel';
import { RegionsAndAreas } from './Pages/RegionsAndAreas';
import { AddRegions } from './Component/RegionsAndAreasComponents/AddRegions';
import { UpdateRegions } from './Component/RegionsAndAreasComponents/UpdateRegions';
import { AreasPage } from './Pages/AreasPage';
import { AddArea } from './Component/Area/AddArea';
import { UpdateArea } from './Component/Area/UpdateArea';
import { CommunicationWayPage } from './Pages/CommunicationWayPage';
import { AddCommunicationWay } from './Component/Communicationway/AddCommunicationWay';
import { UpdateCommunicationWay } from './Component/Communicationway/UpdateCommunicationWay';
import { StagesPage } from './Pages/StagesPage';
import { AddStages } from './Component/Stages/AddStages';
import { AddNewType } from './Component/Stages/AddNewType';
import { ShowAllStageType } from './Component/Stages/ShowAllStageType';
import { UpdateStageType } from './Component/Stages/UpdateStageType';
import { UpdateStages } from './Component/Stages/UpdateStages';
import { CancelReasonsPage } from './Pages/CancelReasonsPage';
import { Addcncelreason } from './Component/CancelReasons/Addcncelreason';
import { Updatecncelreason } from './Component/CancelReasons/Updatecncelreason';
import { UserActivation } from './Component/Auth/UserActivation';
import { LeadAssignedpage } from './Pages/LeadAssignedpage';
import { LeadStagespage } from './Pages/LeadStagespage';
import { CampaignPage } from './Pages/CampaignPage';
import AddCampaign from './Component/Campaign Component/AddCampaign';
import { UpdateCamgaign } from './Component/Campaign Component/UpdateCamgaign';
import { Integrationpage } from './Pages/Integrationpage';
import { HomePage } from './Pages/HomePage';
import { Dashboardpage } from './Pages/Dashboardpage';
import { FacebookIntegrationpage } from './Pages/FacebookIntegrationpage';
import { MoreIntegration } from './Component/Integration Component/MoreIntegration';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { USersPage } from './Pages/UsersPage';
import { EditUserData } from './Pages/EditUserData';
import { ChangePasswordPage } from './Pages/ChangePasswordPage';
import { RotationPage } from './Pages/RotationPage';
import { ManageRotationPage } from './Pages/ManageRotationPage';
import { EditRotationPage } from './Pages/EditRotationPage';
import { MoreRotationPage } from './Pages/MoreRotationPage';
import { EditMoreRotationPage } from './Pages/EditMoreRotationPage';
import { ManageMoreRotationPage } from './Pages/ManageMoreRotationPage';
import { MyAccountPage } from './Pages/MyAccountPage';
import ProtectRoute from './Utility/ProtectedRoute';
import useProtectedRouteHook from './Hook Code/useProtectedRouteHook';
import { LeadsForUsersRolesPage } from './Pages/LeadsForUsersRolesPage';
import { LeadsForTeamLeadersPage } from './Pages/LeadsForTeamLeadersPage';
import { TeamLeaderAssignLeadToSalesPage } from './Pages/TeamLeaderAssignLeadToSalesPage';
import { AllSalesForTeamLeaderPage } from './Pages/AllSalesForTeamLeaderPage';
import { SalesChats } from './Component/Sales/SalesChats';
import { SalesForTeamLeaderWithDiffrentDates } from './Pages/SalesForTeamLeaderWithDiffrentDates';
import { LeadsForManagersPage } from './Pages/LeadsForManagersPage';
import { MyTeamLeadersForManagers } from './Pages/MyTeamLeadersForManagers';
import { ManagerAssignLeadsToSales } from './Pages/ManagerAssignLeadsToSales';
import { ManagerTeamAnylytics } from './Pages/ManagerTeamAnylytics';
import { LeadsForAdmin } from './Component/LeadsForAdmin';
import { MarketingReportsPage } from './Pages/MarketingReportsPage';
import NotFound from './Utility/NotFound';
import { PreviewLeadDetailsPage } from './Pages/PreviewLeadDetailsPage';
import { LeadReviewCommissionPage } from './Pages/LeadReviewCommissionPage';
import { LeadViewCommissionPage } from './Pages/LeadViewCommissionPage';
import { LeadUpdateCommissionpage } from './Pages/LeadUpdateCommissionpage';
import { SalesMonyinMonthReportForAccountantPage } from './Pages/SalesMonyinMonthReportForAccountantPage';
import ReminderHandler from './Utility/ReminderHandler';
import { DeveloperAccountsPage } from './Pages/DeveloperAccountsPage';
import { CommissionSchedualpage } from './Pages/CommissionSchedualpage';
import { CommissionSchedualDatesPreviewpage } from './Pages/CommissionSchedualDatesPreviewpage';
import { UpdateSchedualDateForCommissionPage } from './Pages/UpdateSchedualDateForCommissionPage';
import { DeveloperPaymentsPages } from './Pages/DeveloperPaymentsPages';
import { AccountantTasksPage } from './Pages/AccountantTasksPage';
import { ManageAllAccountantTasks } from './Pages/ManageAllAccountantTasks';
import { CompanyProfilePage } from './Pages/CompanyProfilePage';
import { EditCompanyProfilePage } from './Pages/EditCompanyProfilePage';
import { Footer } from './Utility/Footer';
import { LeadsForMarketerPage } from './Pages/LeadsForMarketerPage';
import { SelectedLeadDuplicationPage } from './Pages/SelectedLeadDuplicationPage';
import { AllLeadsNotActivated } from './Pages/AllLeadsNotActivated';
import { AllStagesTypeTrashPages } from './Pages/Trash/AllStagesTypeTrashPages';
import { AllStagesTrashPage } from './Pages/Trash/AllStagesTrashPage';
import { AllSalesTrashPage } from './Pages/Trash/AllSalesTrashPage';
import { AllUsers_Log_Not_ActivePage } from './Pages/Trash/AllUsers_Log_Not_ActivePage';
import { AllCommunicationWayTrashPage } from './Pages/Trash/AllCommunicationWayTrashPage';
import { AllCampaignTrash } from './Pages/Trash/AllCampaignTrash';
import { AllDevelopersTrash } from './Pages/Trash/AllDevelopersTrash';
import { CancelResanosTrashPage } from './Pages/Trash/CancelResanosTrashPage';
import { AllProjectsTrashPage } from './Pages/Trash/AllProjectsTrashPage';
import { TeamLeaderDashboard } from './Pages/TeamLeaderDashboard';
import { ManagerDashboard } from './Pages/ManagerDashboard';
import { SalesDashboard } from './Pages/SalesDashboard';
// import NotificationListener from "./Socket/NotificationListener";
import { io } from 'socket.io-client';
import { CampaignsReports } from './Pages/CampaignsReports';
import { ChanalsTrashPage } from './Pages/Trash/ChanalsTrashPage';
import { RegionsTrashPage } from './Pages/Trash/RegionsTrashPage';
import { AreaTrashPage } from './Pages/Trash/AreaTrashPage';
import { CitiesTrashPage } from './Pages/Trash/CitiesTrashPage';
import { CheckAndUpdateFCMToken } from './Utility/CheckAndUpdateFCMToken';
import { ImportantMarketingReport } from './Pages/ImportantMarketingReport';
import { FloatingButton } from './Utility/FloatingButton';
import { db_url } from './Api/BaseUrl';
import { UserDevices } from './Component/Auth/UserDevices';
import { AllLeads_For_Admins_Page } from './Pages/AllLeads_For_Admins_Page';
import { All_Leads_For_Sales_Page } from './Pages/All_Leads_For_Sales_Page';
import { All_Leads_For_TeamLeader_Page } from './Pages/All_Leads_For_TeamLeader_Page';
import { AllLeadsForMarketerPage } from './Pages/AllLeadsForMarketerPage';
import { SalesReportCountLeadsInMonths } from './Pages/SalesReportCountLeadsInMonths';
import { DoneDealReportPage } from './Pages/DoneDealReportPage';
import { CrmDataAdminQuickNumbers } from './Component/CRM Data/CrmDataAdminQuickNumbers';
import { AdminAllLeadsCRMData } from './Component/CRM Data/AdminAllLeadsCRMData';
import { TeamLeaderQuickNumbersCRMData } from './Component/CRM Data/TeamLeaderQuickNumbersCRMData';
import { TeamLeaderCRMDATAALLLeads } from './Component/CRM Data/TeamLeaderCRMDATAALLLeads';
import { SalesQuickNumberCRMData } from './Component/CRM Data/SalesQuickNumberCRMData';
import { SalesAllLeadsCRMDATA } from './Component/CRM Data/SalesAllLeadsCRMDATA';
import DoneDealLeadsPage, { AccountantPage } from './Pages/AccountantPage';
import { QuickNumbersForMarketerCRMDATA } from './Component/Dashboard/QuickNumbersForMarketerCRMDATA';
import { All_Leads_For_Marketer_CRM_Data } from './Pages/All_Leads_For_Marketer_CRM_Data';
import { DashboardManagerCRMDATA } from './Pages/DashboardManagerCRMDATA';
import { AllLeadsManagerCRMData } from './Pages/AllLeadsManagerCRMData';
import { AllCompanyDomains } from './Pages/AllCompanyDomains';
import { SupportPage } from './Utility/SupportPage';
import { Toaster } from 'react-hot-toast';
import { LeadsWithSalesinCampaignPage } from './Pages/LeadsWithSalesinCampaignPage';
import { PropertyFinderIntegrationPage } from './Component/Integration Component/PropertyFinderIntegrationPage'; 
import { PFConfigurationPage } from './Component/Integration Component/PFConfigurationPage';

// import { Salesreportcountleads } from "./Pages/Salesreportcountleads";

// const socket = io("https://apirender8.onrender.com"); // ⬅️ غيّر البورت حسب سيرفرك
const socket = io(db_url); // ⬅️ غيّر البورت حسب سيرفرك
// بعد تسجيل الدخول أو بعد معرفة الـ userId

const usersocket = JSON.parse(localStorage.getItem('user'));
const userId = usersocket?.data?._id; // 🟢 ده اللي تبعته
// socket.emit("registerUser", userId);

function App() {
  const [user, isSales, isadmin, isteamleader, isManagers, isAccountant] = useProtectedRouteHook();

  // const fetchData = async () => {
  //   try {
  //     const response = await fetch("https://apirender8.onrender.com/api/v1/users"); // حط الـ API بتاعك هنا
  //     const data = await response.json();
  //     // console.log("Data Updated:", data);
  //     // هنا حدث الـ state بالبيانات الجديدة بدل console.log
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     // if (window.location.pathname !== "/comment") {
  //       fetchData(); // جلب البيانات بدل إعادة تحميل الصفحة
  //     // }
  //   }, 30000); // كل 3 دقائق

  //   return () => clearInterval(interval);
  // }, []);

  // ====================================
  const [mode, setmode] = useState(localStorage.getItem('mode') || 'light');

  // تحديث localStorage عند تغيير المود
  useEffect(() => {
    localStorage.setItem('mode', mode);
  }, [mode]);

  const darkTheme = createTheme({
    palette: {
      mode: mode,
      background: {
        default: mode === 'dark' ? '#1e1e1e' : '#faf6f6',
        paper: mode === 'dark' ? '#1e1e1e' : '#f5f5f5',
      },
      text: {
        primary: mode === 'dark' ? '#ffffff' : '#0a0a0aff',
        secondary: mode === 'dark' ? '#bbbbbb' : '#444444',
      },
    },
  });

  //   function setZoom() {
  //     document.body.style.zoom = "75%";
  // }

  // // ضبط الزوم عند تحميل الصفحة
  // window.onload = setZoom;

  // useEffect(()=>{

  //   // إعادة ضبط الزوم عند أي تغيير
  // window.addEventListener("resize", setZoom);

  // },[])

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (Notification.permission === 'default' || Notification.permission === 'denied') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted');
        } else {
          console.log('Notification permission denied');
        }
      });
    }

    socket.on('newNotification', (data) => {
      console.log('Received', data);

      if (Notification.permission === 'granted') {
        new Notification('New Notification', {
          body: data.message,
          icon: 'https://via.placeholder.com/50',
        });
      }

      setNotifications((prev) => [...prev, data]);
    });

    //   return () => {
    //     socket.off('newNotification');
    //   };
  }, []);

  const [userlogin, setuserlogin] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setuserlogin(user);
    }
  }, []);

  useEffect(() => {
    if (userlogin?.data?._id) {
      CheckAndUpdateFCMToken(userlogin.data._id);
    }
  }, [userlogin]);

  //   useEffect(() => {
  //   const unsubscribe = messaging.onMessage((payload) => {
  //     console.log('📩 Foreground message:', payload);

  //     // عرض notification لو الإذن متاح
  //     if (Notification.permission === 'granted') {
  //       new Notification(payload.notification.title, {
  //         body: payload.notification.body,
  //         icon: '/logo.png',
  //       });
  //     } else {
  //       console.warn('🔕 Notifications are not permitted by the user.');
  //     }
  //   });

  //   return unsubscribe; // تنظيف عند إغلاق الكمبوننت
  // }, []);
  const [shouldHide, setShouldHide] = useState(false);

  useEffect(() => {
  const checkPath = () => {
    const currentPath = window.location.hash || window.location.pathname;
    const hidePaths   = ['/', '#/', '#/Login'];
    const shouldHide  = hidePaths.includes(currentPath);
    setShouldHide(shouldHide);
    setShowNavbar(!shouldHide); // ✅ يخفي الـ navbar في HomePage و Login
  };
  checkPath();
  window.addEventListener('hashchange', checkPath);
  window.addEventListener('popstate',  checkPath);
  return () => {
    window.removeEventListener('hashchange', checkPath);
    window.removeEventListener('popstate',  checkPath);
  };
}, []);
  
  const [showNavbar, setShowNavbar] = useState(true);
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
<Toaster
  position="top-right"
  containerStyle={{ zIndex: 999999 }}
  toastOptions={{ style: { zIndex: 999999 } }}
/>
        {/* userlogin?.data?.role==="Admin"?( */} 

      <>
        {/* باقي الكومبوننتات */}
        {!shouldHide && <FloatingButton />}
      </>
      {/* ):null
} */}
      {/* <ReminderHandler /> */}

      <div
        style={{
          background:
            mode === 'dark' ? { backgroundColor: '#121212' } : { backgroundColor: '#faf6f6' },
        }}
      >
        {/* <NotificationListener /> */}

        {/* <BrowserRouter> */}
        <HashRouter>

          {/* <Navbarheader setmode={setmode} mode={mode} /> */}
{showNavbar && <Navbarheader setmode={setmode} mode={mode} />}


          <Routes>
            {/* Home */}
            {/* <Route path="/navebare" element={<Navbarheader/> }/>  xxxxxxxxxxx*/}

            <Route path="/" element={<HomePage />} />

            {/* <Route path="/dashboard" element={<Dashboardpage/> }/>  */}

            {/* Admin */}
            <Route element={<ProtectRoute auth={isadmin} />}>
              <Route path="/dashboard" element={<Dashboardpage />} />
              <Route path="/client" element={<Clients />} />
              {/* <Route path="/MarketingReports" element={<MarketingReportsPage/> }/>  */}
              <Route path="/PreviewLeadDetails/:id" element={<PreviewLeadDetailsPage />} />
              <Route path="/ImportantMarketingReports" element={<ImportantMarketingReport />} />
                            <Route path="/CompanyDomains" element={<AllCompanyDomains />} />
                            <Route path="/LeadsWithsalesincampaign" element={<LeadsWithSalesinCampaignPage />} />
<Route path="/pf-configuration" element={<PFConfigurationPage />} />
              {/* <Route path="/addclient" element={<AddClients/> }/>  */}
              <Route path="/updateclient/:id" element={<UpdateClient />} />
              {/* <Route path="/assignleed/:id" element={<SendLeedPage/> }/> ------xxx*/}
              {/* <Route path="/assignleed" element={<SendLeedPage/> }/> */}
              {/* <Route path="/salesReciveLeed/:id" element={<RecievedLeedPage/> }/> */}
              {/* <Route path="/LeadAssigned/:id" element={<LeadAssignedpage/> }/> */}
              {/* <Route path="/LeadStages/:id" element={<LeadStagespage/> }/> */}

              <Route path="/AllLeads" element={<LeadsForAdmin />} />
              <Route path="/AllLeadsForAdmin" element={<AllLeads_For_Admins_Page />} />
              <Route
                path="/AllLeadsForAdminCRMDataQuickNumbers"
                element={<CrmDataAdminQuickNumbers />}
              />
              <Route path="/AllLeadsForAdminCRMDatapage" element={<AdminAllLeadsCRMData />} />

              <Route path="/Alllead/:id" element={<LeadsForAdmin />} />
              {/* CompanyProfile */}
              <Route path="/CompanyProfile" element={<CompanyProfilePage />} />
              <Route path="/CompanyProfileEdit/:id" element={<EditCompanyProfilePage />} />
              <Route path="/AllLeadsnotactivated" element={<AllLeadsNotActivated />} />
              <Route path="/AllUserDevices" element={<UserDevices />} />
              <Route
                path="/SalesReportCountLeadsInMonths"
                element={<SalesReportCountLeadsInMonths />}
              />
              <Route path="/DoneDealReport" element={<DoneDealReportPage />} />
              {/* <Route path="/salesreportcountleads" element={<Salesreportcountleads/> }/> */}

              {/* trash */}
              <Route path="/AllStagesTypeTrash" element={<AllStagesTypeTrashPages />} />
              <Route path="/AllStagesTrash" element={<AllStagesTrashPage />} />
              <Route path="/AllSalesTrash" element={<AllSalesTrashPage />} />
              <Route path="/AllUsersTrash" element={<AllUsers_Log_Not_ActivePage />} />
              <Route path="/AllCommWayTrash" element={<AllCommunicationWayTrashPage />} />
              <Route path="/AllCampaignTrash" element={<AllCampaignTrash />} />
              <Route path="/AllDevelopersTrash" element={<AllDevelopersTrash />} />
              <Route path="/CancelResanosTrash" element={<CancelResanosTrashPage />} />
              <Route path="/AllProjectsTrash" element={<AllProjectsTrashPage />} />

              <Route path="/ChanalsTrash" element={<ChanalsTrashPage />} />
              <Route path="/RegionsTrash" element={<RegionsTrashPage />} />
              <Route path="/AreaTrash" element={<AreaTrashPage />} />
              <Route path="/CitiesTrash" element={<CitiesTrashPage />} />
            </Route>

            {/* Sales */}
            <Route element={<ProtectRoute auth={isSales} />}>
              <Route path="/SalesDashboard" element={<SalesDashboard />} />

              {/* <Route path="/LeadsForUsers"  element={isSales ? <Navigate to="/LeadsForUsers" replace /> : <Dashboardpage />}/>  */}
              {/* <Route path="/LeadsForUsers" element={<LeadsForUsersRolesPage/> }/>  */}
              {/* <Route path="/SalesCharts" element={<SalesChats/> }/>  */}
              <Route path="/AllLeadsForSales" element={<All_Leads_For_Sales_Page />} />
              <Route path="/SalesQuickNumberCRMData" element={<SalesQuickNumberCRMData />} />
              <Route path="/SalesAllLeadsCRMDATA" element={<SalesAllLeadsCRMDATA />} />
            </Route>

            {/* Team Leader */}
            <Route element={<ProtectRoute auth={isteamleader} />}>
              <Route path="/TeamleaderDashboard" element={<TeamLeaderDashboard />} />

              {/* <Route path="/LeadsForTeamLeaders" element={<LeadsForTeamLeadersPage/> }/>  */}

              <Route path="/AllLeadsForTeamLeader" element={<All_Leads_For_TeamLeader_Page />} />

              <Route
                path="/TeamLeaderAssignLeadToSales"
                element={<TeamLeaderAssignLeadToSalesPage />}
              />
              <Route path="/TeamLeaderMysales" element={<AllSalesForTeamLeaderPage />} />
              <Route
                path="/SalesForTeamLeaderWithDiffrentDates"
                element={<SalesForTeamLeaderWithDiffrentDates />}
              />
              <Route
                path="/TeamLeaderQuickNumbersCRMData"
                element={<TeamLeaderQuickNumbersCRMData />}
              />
              <Route path="/TeamLeaderCRMDATAALLLeads" element={<TeamLeaderCRMDATAALLLeads />} />
            </Route>

            {/* Managers */}
            <Route element={<ProtectRoute auth={isManagers} />}>
              <Route path="/ManagerDashboard" element={<ManagerDashboard />} />
              <Route path="/LeadsForManagers" element={<LeadsForManagersPage />} />
              <Route path="/MyTeamLeadersForManagers" element={<MyTeamLeadersForManagers />} />
              <Route path="/ManagerAssignLeadToSales" element={<ManagerAssignLeadsToSales />} />
              <Route path="/TeamAnalyticForManager" element={<ManagerTeamAnylytics />} />
              <Route path="/dashboradmanagerCrmData" element={<DashboardManagerCRMDATA />} />
              <Route path="/AllLeadsManagercrmdata" element={<AllLeadsManagerCRMData />} />

              {/* <Route path="/SalesForTeamLeaderWithDiffrentDates" element={<SalesForTeamLeaderWithDiffrentDates/> }/>   */}
            </Route>

            {/* Accountant */}
            <Route element={<ProtectRoute auth={isAccountant} />}>
              <Route path="/LeadsForAccountant" element={<AccountantPage />} />
              <Route path="/LeadReviewCommission/:id" element={<LeadReviewCommissionPage />} />
              <Route path="/ViewCommission/:id" element={<LeadViewCommissionPage />} />
              <Route path="/LeadUpdateCommission/:id" element={<LeadUpdateCommissionpage />} />
              <Route
                path="/SalesMonyinMonthReportForAccountant"
                element={<SalesMonyinMonthReportForAccountantPage />}
              />
              <Route path="/DeveloperAccounts" element={<DeveloperAccountsPage />} />
              <Route path="/CommissionSchedual/:id" element={<CommissionSchedualpage />} />
              <Route
                path="/ShowAllPaymentsDates/:id"
                element={<CommissionSchedualDatesPreviewpage />}
              />
              <Route
                path="/UpdateSchedualDateForCommission/:id"
                element={<UpdateSchedualDateForCommissionPage />}
              />
              <Route path="/DeveloperPayments" element={<DeveloperPaymentsPages />} />
              <Route path="/AccountantTasks" element={<AccountantTasksPage />} />
              <Route path="/ManageAccountantTasks" element={<ManageAllAccountantTasks />} />
            </Route>

            {/* Leads For Marketer */}
            {/* <Route path="/LeadsForMarketer" element={<LeadsForMarketerPage/> }/>  */}
            <Route path="/ALLLeadsForMarketer" element={<AllLeadsForMarketerPage />} />
            <Route
              path="/QuickNumbersForMarketerCRMDATA"
              element={<QuickNumbersForMarketerCRMDATA />}
            />

            <Route
              path="/ALLLeadsForMarketerCRMDATA"
              element={<All_Leads_For_Marketer_CRM_Data />}
            />

            <Route path="/Login" element={<Login />} />

            {/* client */}
            {/* <Route path="/client" element={<Clients/> }/>  */}

            {/* developers */}
            <Route path="/Developers" element={<AllDevelopersMain />} />
            <Route path="/AddDeveloper" element={<AddDevelopers />} />
            <Route path="/UpdateDeveloper/:id" element={<UpdateOneDeveloperData />} />

            {/* projects */}
            <Route path="/Project" element={<AllProjects />} />
            <Route path="/Addprojects" element={<AddProjects />} />
            <Route path="/updateproject/:id" element={<UpdateProject />} />

            {/* cities */}
            <Route path="/AddCity" element={<AddCity />} />
            <Route path="/AllCitiesShow" element={<AllCitiesShow />} />
            <Route path="/updateCity/:id" element={<UpdateCity />} />

            {/* Sales */}
            <Route path="/Addsales" element={<AddSales />} />
            <Route path="/sales" element={<SalesMain />} />
            <Route path="/updatesales/:id" element={<UpdateSales />} />
            <Route path="/client/:id" element={<Clients />} />

            {/* Auth */}
            <Route path="/Rigister" element={<Rigister />} />
            {/* <Route path="/user_activation" element={<UserActivation/> }/>  */}
            <Route path="/Register/:id" element={<EditUserData />} />
            <Route path="/ChangePassword/:id" element={<ChangePasswordPage />} />
            <Route path="/MyAccount" element={<MyAccountPage />} />

            {/* stage */}
            {/* <Route path="/updatestage/:id/:salesID" element={<UpdateStage/> }/>  */}

            <Route path="/LeadStages/:id" element={<LeadStagespage />} />

            {/* channel */}
            <Route path="/Channel" element={<ChannelPage />} />
            <Route path="/channal/addchannal" element={<AddChannal />} />
            <Route path="/channal/updatechannal/:id" element={<UpdateChanel />} />

            {/* Regions and Area */}
            <Route path="/Regionsandareas" element={<RegionsAndAreas />} />
            <Route path="/AddRegions" element={<AddRegions />} />
            <Route path="/RegionsUpdate/:id" element={<UpdateRegions />} />

            {/* Areas */}
            <Route path="/Areas" element={<AreasPage />} />
            <Route path="/AddArea" element={<AddArea />} />
            <Route path="/updateArea/:id" element={<UpdateArea />} />

            {/* Communication way */}
            <Route path="/Communicationway" element={<CommunicationWayPage />} />
            <Route path="/AddCommunicationway" element={<AddCommunicationWay />} />
            <Route path="/UpdateCommunicationway/:id" element={<UpdateCommunicationWay />} />

            {/* stages */}
            <Route path="/Stages" element={<StagesPage />} />
            <Route path="/AddStages" element={<AddStages />} />
            <Route path="/AddNewTypeForstage" element={<AddNewType />} />
            <Route path="/ShowAllstageTypes" element={<ShowAllStageType />} />
            <Route path="/updatestagetype/:id" element={<UpdateStageType />} />
            <Route path="/updatestagesAdmin/:id" element={<UpdateStages />} />

            {/* cancel reason */}
            <Route path="/cancelreasons" element={<CancelReasonsPage />} />
            <Route path="/addreason" element={<Addcncelreason />} />
            <Route path="/updatecancelreason/:id" element={<Updatecncelreason />} />

            {/* campaigns */}
            <Route path="/Campaigns" element={<CampaignPage />} />
            <Route path="/AddCampaigns" element={<AddCampaign />} />
            <Route path="/updatecampaign/:id" element={<UpdateCamgaign />} />

            {/* integration */}
            <Route path="/integration" element={<Integrationpage />} />
            <Route path="/Facebookintegration" element={<FacebookIntegrationpage />} />
            <Route path="/MoreIntegration" element={<MoreIntegration />} />
            <Route path="/Users" element={<USersPage />} />

            {/* Rotaion */}
            <Route path="/Rotation" element={<RotationPage />} />
            <Route path="/manageRotation" element={<ManageRotationPage />} />
            <Route path="/EditRotation/:id" element={<EditRotationPage />} />
            <Route path="/MoreRotation" element={<MoreRotationPage />} />
            <Route path="/EditMoreRotation/:id" element={<EditMoreRotationPage />} />
            <Route path="/ManageMoreRotation" element={<ManageMoreRotationPage />} />
            <Route path="/updatestage/:id/:salesID" element={<UpdateStage />} />

            <Route path="/LeadAssigned/:id" element={<LeadAssignedpage />} />
            <Route path="/addclient" element={<AddClients />} />
            <Route path="/LeadDuplication/:id" element={<SelectedLeadDuplicationPage />} />

            <Route path="/salesReciveLeed/:id" element={<RecievedLeedPage />} />
                        <Route path="/support" element={<SupportPage />} />
<Route path="/property-finder-integration" element={<PropertyFinderIntegrationPage />} />


            {/* Marketing and admins   Shares Routes */}
            <Route path="/MarketingReports" element={<MarketingReportsPage />} />
            <Route path="/CampaignsReports" element={<CampaignsReports />} />
            <Route path="/assignleed" element={<SendLeedPage />} />

            {/* صفحة 404 */}
            {/* <Route path="*" element={<NotFound />} /> */}
            <Route path="*" element={<NotFound setShowNavbar={setShowNavbar} />} />

          </Routes>
          {/* </BrowserRouter> */}
        </HashRouter>
        {/* <Footer/> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
